var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingQuestIntro } from "../../balancingSelectors/selectBalancingQuestIntros";
import { IdStyles } from "../../less/IdStyles";
import { selectIsModalOpen } from "../../selectors/selectModalTabId";
import { selectIsQuestCompleted, selectIsQuestListed, selectSelectedQuest, } from "../../selectors/selectQuestInfo";
import { selectIsQuestVisited } from "../../selectors/selectVisitedQuests";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { TextLoca } from "../generic/text/TextLoca";
import { actionQuestVisited } from "../info/quest/list/actionQuests";
import { IdModal } from "../modals/IdModal";
import { TransparentDialogWrapper } from "../transparent-dialog/TransparentDialogWrapper";
import { IdQuestIntrosPointerDirection } from "./IdQuestIntrosPointerDirection";
var DialogQuestIntrosDOM = /** @class */ (function (_super) {
    __extends(DialogQuestIntrosDOM, _super);
    function DialogQuestIntrosDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeIntroSequenceIndex: 0,
        };
        _this.getQuestIntoContent = function (activeIntroSequence) {
            var bigCharacterPlacement = {};
            if (activeIntroSequence.pointerDirection === IdQuestIntrosPointerDirection.Left) {
                bigCharacterPlacement.left = _this.getBigCharacter(activeIntroSequence);
                bigCharacterPlacement.pointerStyle = "quest-intro-pointer-left";
            }
            else if (activeIntroSequence.pointerDirection === IdQuestIntrosPointerDirection.Right) {
                bigCharacterPlacement.right = _this.getBigCharacter(activeIntroSequence);
                bigCharacterPlacement.pointerStyle = "quest-intro-pointer-right";
            }
            return (React.createElement(TransparentDialogWrapper, { overlay: false },
                React.createElement("div", { className: "quest-intro__dialog" },
                    bigCharacterPlacement.left,
                    React.createElement("div", { className: "quest-intro-balloon " + IdStyles.QuestIntroBalloon + " " + bigCharacterPlacement.pointerStyle },
                        React.createElement("div", { className: IdStyles.TextBoldAccent },
                            React.createElement(TextLoca, { id: activeIntroSequence.headerLocaId })),
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: activeIntroSequence.bodyLocaId }))),
                    React.createElement("div", { className: "quest-intro__button-text" },
                        React.createElement(TextLoca, { className: IdStyles.HeadlineOne, id: IdLoca.tapToContinue_web })),
                    bigCharacterPlacement.right)));
        };
        _this.getBigCharacter = function (activeIntroSequence) { return (React.createElement(BigCharacter, { className: "flex__full", name: IdBigCharacter[activeIntroSequence.characterName] })); };
        _this.onContinue = function () {
            var activeIndex = _this.state.activeIntroSequenceIndex;
            _this.setState({ activeIntroSequenceIndex: activeIndex + 1 });
            return;
        };
        return _this;
    }
    DialogQuestIntrosDOM.prototype.render = function () {
        var _this = this;
        var _a = this.props, questIntro = _a.questIntro, onComplete = _a.onComplete, shouldRender = _a.shouldRender;
        if (!shouldRender) {
            return React.createElement(React.Fragment, null);
        }
        var activeSequenceIndex = this.state.activeIntroSequenceIndex;
        var activeIntroSequence = questIntro.sequence[activeSequenceIndex];
        var questIntroContent = this.getQuestIntoContent(activeIntroSequence);
        var nextIntroSequence = questIntro.sequence[activeSequenceIndex + 1];
        return (React.createElement("div", null,
            React.createElement("div", { className: "quest-intro__overlay", onClick: nextIntroSequence
                    ? this.onContinue
                    : function () { return onComplete(_this.props.selectedQuest.id); } }, questIntroContent)));
    };
    return DialogQuestIntrosDOM;
}(React.Component));
var mapState = function (state) {
    var selectedQuest = selectSelectedQuest(state);
    var isModalOpen = selectIsModalOpen(state, IdModal.Quests);
    var isQuestVisited = true;
    var isQuestCompleted = false;
    var isQuestInList = true;
    var questIntro;
    if (selectedQuest != undefined) {
        isQuestCompleted = selectIsQuestCompleted(state, selectedQuest);
        isQuestVisited = selectIsQuestVisited(selectedQuest.id);
        isQuestInList = selectIsQuestListed(state, selectedQuest.id);
        questIntro = selectBalancingQuestIntro(selectedQuest.id);
    }
    var shouldRender = isModalOpen &&
        !isQuestCompleted &&
        !isQuestVisited &&
        questIntro != undefined &&
        isQuestInList;
    return {
        questIntro: questIntro,
        selectedQuest: selectedQuest,
        shouldRender: shouldRender,
    };
};
var mapDispatch = function (dispatch) { return ({
    onComplete: function (questId) { return dispatch(actionQuestVisited(questId)); },
}); };
export var DialogQuestIntros = connect(mapState, mapDispatch)(DialogQuestIntrosDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/quest-intros/DialogQuestIntros.tsx
// module id = 2888
// module chunks = 3